import {
    FETCH_HELP_TOPICS_REQUEST,
    FETCH_HELP_TOPICS_SUCCESS,
    FETCH_HELP_TOPICS_FAILURE,
} from "./types";

import {
    fetchHelpTopics,
} from "../../services/helpTopicService";

export const fetchHelpTopicsAction =
    (
        page = 1,
        size = 50
    ) =>
    async (
        dispatch
    ) => {

        dispatch({
            type:
                FETCH_HELP_TOPICS_REQUEST,
        });

        const result =
            await fetchHelpTopics(
                page,
                size
            );

        if (
            result.success
        ) {
            dispatch({
                type:
                    FETCH_HELP_TOPICS_SUCCESS,
                payload:
                    result.data,
            });
        } else {
            dispatch({
                type:
                    FETCH_HELP_TOPICS_FAILURE,
                payload:
                    result.error,
            });
        }

        return result;
    };